import { render, staticRenderFns } from "./ProblemPieceNotice.vue?vue&type=template&id=040cc472&scoped=true"
import script from "./ProblemPieceNotice.vue?vue&type=script&lang=js"
export * from "./ProblemPieceNotice.vue?vue&type=script&lang=js"
import style0 from "./ProblemPieceNotice.vue?vue&type=style&index=0&id=040cc472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040cc472",
  null
  
)

export default component.exports